import { Box, Button } from "@mui/material";
import React from "react";
import RenderFormNew from "../../../Components/Esaedro/RenderForm/RenderFormNew";
import { useFieldObjEdit } from "./FieldList";
import { useSelector } from "react-redux";
import { RootState } from "../../../BusinessObjects/Redux/app/store";
import { useNavigate } from "react-router-dom";
import { Form } from "../../../Models/SysConf/Form";
import { useQuery } from "react-query";
import cubeApiClient from "../../../BusinessObjects/cubeApiService";
import { ResourceNames } from "../../../Utils/ResourceNames";
import { RoutePath } from "../../../Utils/RoutePath";
import notify from "devextreme/ui/notify";

type Props = {};

const FieldListEdit = (props: Props) => {
  const { objEdit, setObjEdit } = useFieldObjEdit();

  //Redux
  const tokenApi = useSelector((state: RootState) => state.user.tokenAPI);
  const userProfile = useSelector((state: RootState) => state.user.userProfile);
  const isLoggedIn = useSelector((state: RootState) => state.user.isLoggedIn);

  // React Router DOM
  const navigate = useNavigate();

  // Chiamata Api
  const {
    data: resourcesViewsFields,
    isLoading: isLoadingResourcesViewsFields,
    isError: isErrorResourcesViewsFields,
    refetch: refetchResourcesViewsFields,
    isRefetching: isRefetchingResourcesViewsFields,
  } = useQuery(
    ["resourcesViewsFields", objEdit?.View_ID, tokenApi],
    () => {
      var urlToUse = `api/sys/${ResourceNames.ResourcesViewsFields}?RecordSelection=View_ID=${objEdit?.View_ID}`;
      const service = new cubeApiClient();

      return service.getItems(urlToUse, tokenApi);
    },
    {
      enabled: true,
      refetchOnWindowFocus: false,
      retry: 0,
      refetchInterval: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchIntervalInBackground: false,
    }
  );

  const {
    data: formResourcesViewsFields,
    isLoading: isLoadingFormResourcesViewsFields,
  } = useQuery(
    [
      "form",
      ResourceNames.ResourcesViewsFields,
      userProfile?.customer_ID,
      tokenApi,
    ],
    () => {
      const service = new cubeApiClient();

      return service
        .getItems(
          `api/sys/${ResourceNames.Resources}?RecordSelection=ResourceName='${ResourceNames.ResourcesViewsFields}'`,
          tokenApi
        )
        .then(
          (data: any) => {
            let urlForm = `api/sys/${ResourceNames.Forms}/query?ResourceId=${data[0].Resource_ID}`;

            return service.getItems(urlForm, tokenApi).then(
              (data: any) => {
                return data[0];
              },
              (error: any) => {
                return undefined;
              }
            );
          },
          (error: any) => {
            return undefined;
          }
        );
    },
    {
      enabled: isLoggedIn,
      refetchOnWindowFocus: false,
      retry: 0,
      refetchInterval: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchIntervalInBackground: false,
    }
  );

  const formResourceViewField: Form | undefined = React.useMemo(() => {
    if (formResourcesViewsFields) {
      let tmpForm: Form = formResourcesViewsFields;

      tmpForm.FormsGroups.forEach((fg) => {
        fg.FormsFields.forEach((ff) => {
          if (ff.FieldName === "View_ID") {
            ff.Is_Editable = false;
          }
        });
      });

      return tmpForm;
    }

    return undefined;
  }, [formResourcesViewsFields]);

  // Chiamata per salvare un nuovo campo
  const saveNewResourceViewField = () => {
    const service = new cubeApiClient();

    service
      .updateObject(
        objEdit,
        `api/sys/${ResourceNames.ResourcesViewsFields}`,
        tokenApi
      )
      .then(
        (data) => {
          refetchResourcesViewsFields();
          navigate(
            `${RoutePath.RESOURCES_VIEWS}/${objEdit?.View_ID}/field_list`
          );
          notify("Campo salvato con successo", "success", 1000);
        },
        (error) => {
          refetchResourcesViewsFields();
          notify("Errore nel salvataggio del campo", "error", 1000);
        }
      );
  };

  // ! Inizio DOM
  return (
    <>
      <Box
        sx={{
          width: "100%",
          height: "100%",
          justifyContent: "space-around",
          alignItems: "center",
          mt: 1,
          flexDirection: "row",
          mb: 3,
        }}
      >
        <React.Fragment>
          <RenderFormNew
            showTitle={false}
            isNew={false}
            form={formResourceViewField}
            myObj={objEdit}
            saveNewObject={(e) => setObjEdit(e)}
          />
        </React.Fragment>
      </Box>
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          mt: 1,
          flexDirection: "row",
        }}
      >
        <Button
          variant="contained"
          color="error"
          className="me-2"
          onClick={() =>
            navigate(
              `${RoutePath.RESOURCES_VIEWS}/${objEdit?.View_ID}/field_list`
            )
          }
        >
          Annulla
        </Button>
        <Button
          variant="contained"
          color="success"
          onClick={() => saveNewResourceViewField()}
        >
          Salva
        </Button>
      </Box>
    </>
  );
};

export default FieldListEdit;
